export const getDeepProp = (root, ...props) => {
    try {
        return props.reduce((a, i) => a[i], root);
    } catch {
        return null;
    }
};
